import styled from 'styled-components';

const DefaultIcon = styled.div`
  .default-icon {
    &--image-default {
      background-color: #0F8495;
      padding: 10px;
      border-radius: 100%;
    }
  }
`;

export default DefaultIcon;
